var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"id":"iframe","width":"100%","height":_vm.height,"align":"middle","srcdoc":_vm.mailing}})])}
var staticRenderFns = []

export { render, staticRenderFns }